import toast from '@liquidweb-dev/undercurrent/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicSupportRequestReplyParamsRawI,
	LWApiPublicSupportRequestReplyResultRawI,
	LWApiPublicSupportRequestDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/support/request/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { SUPPORT_REQUEST_DETAILS_QUERY_KEY } from './useDetails';
import { SUPPORT_REQUEST_LIST_QUERY_KEY } from './useList';

const useSupportRequestReply = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicSupportRequestReplyResultRawI,
		ApiErrorI,
		LWApiPublicSupportRequestReplyParamsRawI
	>({
		mutationFn: (params) => api.support.request.apiRaw.reply(params),
		onSuccess: (data) => {
			toast.success('Reply saved');

			const ticketNumber = data.case_details?.ticket_number;
			if (ticketNumber) {
				queryClient.invalidateQueries({
					queryKey: [
						SUPPORT_REQUEST_DETAILS_QUERY_KEY,
						{ ticket_number: ticketNumber },
					],
				});

				queryClient.setQueriesData<LWApiPublicSupportRequestDetailsResultRawI>(
					{
						queryKey: [
							SUPPORT_REQUEST_DETAILS_QUERY_KEY,
							{ ticket_number: ticketNumber },
						],
					},
					(old) => {
						if (!old) return old;

						return {
							...old,
							...data.case_details,
						};
					},
				);
			}

			queryClient.invalidateQueries({
				queryKey: [SUPPORT_REQUEST_LIST_QUERY_KEY],
			});
		},
		onError: snackbarError,
	});
};

export default useSupportRequestReply;
